import { useState, useEffect } from 'react';
import { toast } from '@/components/ui/toast';
import { getDraftByIdFromStorage, type CheckInDraft } from './use-drafts';
import { getMenuItemById } from '@/api/endpoints/menu-items';

export function useDraftLoader(draftId: string | undefined) {
  const [isLoading, setIsLoading] = useState(!!draftId);
  const [draft, setDraft] = useState<CheckInDraft | null>(null);

  useEffect(() => {
    if (!draftId) return;
    let cancelled = false;

    async function load() {
      const loaded = await getDraftByIdFromStorage(draftId!);
      if (cancelled) return;

      if (loaded?.menuItem) {
        try {
          await getMenuItemById(loaded.menuItem.id);
        } catch {
          if (!cancelled) {
            toast.warning('Menu item no longer available', {
              description: 'The dish in this draft is no longer available. Please select a new menu item.',
            });
            setDraft({ ...loaded, menuItem: null });
            setIsLoading(false);
            return;
          }
        }
      }

      if (!cancelled) {
        setDraft(loaded);
        setIsLoading(false);
      }
    }

    load();
    return () => { cancelled = true; };
  }, [draftId]);

  return { isLoading, draft };
}
